import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Orcamento } from '../models/orcamento.model';
import { OrcamentoParametro } from '../models/orcamento-parametro.model';
import { OrcamentosListDto } from '../models/orcamento-list-response.dto';
import { FiltrarOrcamento } from '../models/orcamento-filter.model';
import { ParametrosOrcamentoDefault } from '../models/parametros-orcamento-default.model';
import { CriarOrcamentoDto } from '../dtos/criar-orcamento.dto';

@Injectable({
  providedIn: 'root'
})
export class OrcamentoService {
  private _apiUrl = environment.apiUrl + "/v1/Orcamento";

  private loadingSubject = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) { }

  registrarParametro(orcamento: Orcamento) {

    const payload: OrcamentoParametro =  {

      id: orcamento.id,
      projetofeiraId: (orcamento as any).projetoFeiraId || null, // Mapear para o nome que a API espera
      statusOrcamento: (orcamento as any).statusOrcamento !== undefined && (orcamento as any).statusOrcamento !== null 
        ? Number((orcamento as any).statusOrcamento) 
        : 0, // Se não tiver valor, usar 0 (Orçando) como padrão conforme enum
      comprimento: Number(orcamento.comprimento),
      largura: Number(orcamento.largura),
      comprimentoSobrepor: Number(orcamento.comprimentoSobrepor),
      larguraSobrepor: Number(orcamento.larguraSobrepor),
      percentualImpostoFaturaIsentoIss: Number(orcamento.percentualImpostoFaturaIsentoIss),
      percentualCustoOperacional: Number(orcamento.percentualCustoOperacional),
      percentualMargemDeLucro: Number(orcamento.percentualMargemDeLucro),
      percentualVariacaoOrcamento: Number(orcamento.percentualVariacaoOrcamento),
      percentualComissaoVendas: Number(orcamento.percentualComissaoVendas),
      percentualStudioArquiteto: Number(orcamento.percentualStudioArquiteto),
      percentualMargemNegociacao: Number(orcamento.percentualMargemNegociacao)
    };


    return this.http.put(`${this._apiUrl}/parametros`, payload )
    .pipe(
      finalize(() => this.loadingSubject.next(false))
    )
  }

  consultarOrcamento(orcamentoId: string): Observable<Orcamento> {
    return this.http.get<Orcamento>(`${this._apiUrl}/${orcamentoId}`)
    .pipe(
      finalize(() => this.loadingSubject.next(false))
    )
  }

  listarOrcamentos(filtros: FiltrarOrcamento): Observable<OrcamentosListDto> {
    this.loadingSubject.next(true);
    
    let params = new HttpParams()
      .set('PaginaAtual', filtros.paginaAtual || '0')
      .set('QuantidadePorPagina', filtros.quantidadePorPagina || '10');
    
    if (filtros.Cliente) {
      params = params.set('Cliente', filtros.Cliente);
    }
    
    if (filtros.Projeto) {
      params = params.set('Projeto', filtros.Projeto);
    }

    return this.http.get<OrcamentosListDto>(this._apiUrl, { params })
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      );
  }

  consultarParametrosPadrao(): Observable<ParametrosOrcamentoDefault> {
    this.loadingSubject.next(true);
    const parametrosUrl = environment.apiUrl + "/v1/ParametrosOrcamento";
    
    return this.http.get<ParametrosOrcamentoDefault>(parametrosUrl)
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      );
  }

  criarOrcamento(dto: CriarOrcamentoDto): Observable<any> {
    this.loadingSubject.next(true);
    return this.http.post<any>(this._apiUrl, dto)
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      );
  }
}
